export const LOGIN_START = 'LOGIN_START';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const REGISTER_START = 'REGISTER_START';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';

export const REGISTER_ISSUER_START = 'REGISTER_ISSUER_START';
export const REGISTER_ISSUER_ERROR = 'REGISTER_ISSUER_ERROR';
export const REGISTER_ISSUER_SUCCESS = 'REGISTER_ISSUER_SUCCESS';

export const UPDATE_ISSUER_START = 'UPDATE_ISSUER_START';
export const UPDATE_ISSUER_ERROR = 'UPDATE_ISSUER_ERROR';
export const UPDATE_ISSUER_SUCCESS = 'UPDATE_ISSUER_SUCCESS';

export const SHOW_CONFIRM_EMAIL = 'SHOW_CONFIRM_EMAIL';

export const GET_ISSUER_START = 'GET_ISSUER_START';
export const GET_ISSUER_ERROR = 'GET_ISSUER_ERROR';
export const GET_ISSUER_SUCCESS = 'GET_ISSUER_SUCCESS';

export const DELETE_ISSUER_START = 'DELETE_ISSUER_START';
export const DELETE_ISSUER_ERROR = 'DELETE_ISSUER_ERROR';
export const DELETE_ISSUER_SUCCESS = 'DELETE_ISSUER_SUCCESS';

export const CONFIRM_REGISTER_START = 'CONFIRM_REGISTER_START';
export const CONFIRM_REGISTER_ERROR = 'CONFIRM_REGISTER_ERROR';
export const CONFIRM_REGISTER_SUCCESS = 'CONFIRM_REGISTER_SUCCESS';

export const RESET_PASSWORD_REQUEST_START = 'RESET_PASSWORD_REQUEST_START';
export const RESET_PASSWORD_REQUEST_ERROR = 'RESET_PASSWORD_REQUEST_ERROR';
export const RESET_PASSWORD_REQUEST_SUCCESS = 'RESET_PASSWORD_REQUEST_SUCCESS';

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const LOGOUT = 'LOGOUT';

export const STORE_SESSION = 'STORE_SESSION';
export const SET_USER = 'SET_USER';
